import PendingAndActiveList from '@/views/App/TravelExpenses/User/List/PendingAndActive.vue';
import ApprovedList from '@/views/App/TravelExpenses/User/List/Approved.vue';
import Details from "@/views/App/TravelExpenses/User/Details/Details.vue";
import DetailsRefresh from "@/views/App/TravelExpenses/User/Details/DetailsRefresh.vue";
import DetailsCoordinator from "@/views/App/TravelExpenses/Coordinator/Details/Details.vue";
import PendingAndActiveListForCoordinator from '@/views/App/TravelExpenses/Coordinator/List/PendingAndActive.vue';
import ApprovedListForCoordinator from '@/views/App/TravelExpenses/Coordinator/List/Approved.vue';

const routesTravelExpenses = [
    // User
    {
        path: 'pending-and-active-list',
        name: 'travelExpensesPendingAndActiveList',
        component: PendingAndActiveList
    },
    {
        path: 'approved-list',
        name: 'travelExpensesApprovedList',
        component: ApprovedList
    },
    {
        path: 'submit-for-approval',
        name: 'submitForApproval',
        component: PendingAndActiveList
    },
    {
        path: 'details/:id?',
        name: 'travelExpensesDetails',
        component: Details
    },
    {
        path: 'details-refresh',
        name: 'travelExpensesDetailsRefresh',
        component: DetailsRefresh
    },

    // Coordinator
    {
        path: 'pending-and-active-list-for-coordinator',
        name: 'travelExpensesPendingAndActiveListForCoordinator',
        component: PendingAndActiveListForCoordinator
    },
    {
        path: 'approved-list-for-coordinator',
        name: 'travelExpensesApprovedListForCoordinator',
        component: ApprovedListForCoordinator
    },
    {
        path: 'coordinator-details/:id?',
        name: 'coordinatorTravelExpensesDetails',
        component: DetailsCoordinator
    },
];

export default routesTravelExpenses;